var map = {
	"./Abhishek Gupta.jpg": 6219,
	"./Adarsh Kumar Tiwari.jpg": 1392,
	"./Amit Pratap.jpg": 2521,
	"./B Mohan Sudesh.jpg": 2462,
	"./Battu Lochana Janaki.jpg": 9548,
	"./Chaithanya Krishna Moorthy.jpg": 692,
	"./Dasi Manoj Kumar.jpg": 5284,
	"./G Suryanarayanan.jpg": 7267,
	"./Ishan Natu.jpg": 1597,
	"./K Dhanusha.jpg": 4831,
	"./Krishna Narwani.jpg": 9465,
	"./Lokesh Lakhani.jpg": 9363,
	"./M G Raja Sree.jpg": 3913,
	"./Manankumar Patel.jpg": 5266,
	"./Manideep Ladi.jpg": 7768,
	"./Manoj Sundararajan.jpg": 3250,
	"./Mansi Hada.jpg": 2908,
	"./Palvai Ravi Ram Reddy.jpg": 1291,
	"./Ritesh Bennabhaktula.jpg": 1711,
	"./Sai Charan Nalla.jpg": 610,
	"./Shubham Tibrewal.jpg": 2389,
	"./Subodh Joshi.jpg": 9197,
	"./Surender Naik Kethavath.jpg": 2827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 433;